import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JPDProjectViewConfigProviderEntrypointProps } from './JPDProjectViewConfigProvider.entrypoint.types.tsx';

type JPDProjectViewConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JPDProjectViewConfigProviderEntrypointProps,
	{} | null
>;

export const jpdProjectViewConfigProviderEntrypoint: EntryPoint<
	JPDProjectViewConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<JPDProjectViewConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-jpd-project-view-provider" */ './JPDProjectViewConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
